import { Box, styled } from '@mui/material';

export const LinksContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
